import { adminHttpClient } from '../../commons/adminHttpClient'

export interface AllowanceSpentResponse {
  allowanceUsed: number
  percentageIncrease: number
  totalAllowance: number
  percentageUsed: number
}

export const getAllowanceSpent = (planPeriodId: string, date?: string): Promise<AllowanceSpentResponse[]> => {
  return adminHttpClient.get(`/Expenses/Reports/AllowanceSpent/${planPeriodId}${date ? `?date=${date}` : ''}`)
}
